// extracted by mini-css-extract-plugin
export var childrenContainer = "_c1-0";
export var virtualScrollArea = "_c1-1";